// Page
export const SET_PAGE_LOADING = 'SET_PAGE_LOADING';

// Viewport
export const SET_VIEWPORT = 'SET_VIEWPORT';
export const SET_PAGE_VISIBILITY = 'SET_PAGE_VISIBILITY';

// Logos
export const SET_LOGO = 'SET_LOGO';

// sidebar blocks
export const SET_SIDEBAR_OPEN_BLOCK = 'SET_SIDEBAR_OPEN_BLOCK';
export const SET_SIDEBAR_BLOCK_ID = 'SET_SIDEBAR_BLOCK_ID';
export const SET_SIDEBAR_BLOCK_BOUNDS = 'SET_SIDEBAR_BLOCK_BOUNDS';

// Side navitation
export const TOGGLE_SIDE_NAVIGATION = 'TOGGLE_SIDE_NAVIGATION';

// Wizard
export const UPDATE_WIZARD_TOGGLE = 'UPDATE_WIZARD_TOGGLE';
export const UPDATE_WIZARD_BIRTHDATE = 'UPDATE_WIZARD_BIRTHDATE';
export const UPDATE_WIZARD_REFERENCE_AUTHORIZATION = 'UPDATE_WIZARD_REFERENCE_AUTHORIZATION';
export const UPDATE_LEGAL_GUARDIAN_VISIBILITY = 'UPDATE_LEGAL_GUARDIAN_VISIBILITY';
export const UPDATE_WIZARD_SUB_STEP = 'UPDATE_WIZARD_SUB_STEP';
export const UPDATE_RADIO_TAG_GROUPS = 'UPDATE_RADIO_TAG_GROUPS';
export const UPDATE_NUMBER_OF_OPTIONAL_DOCUMENTS = 'UPDATE_NUMBER_OF_OPTIONAL_DOCUMENTS';
